/// <amd-module name="Release/Landing/HubContent/Releases/ReleasesViewActions" />
import { IObservableValue } from "VSS/Core/Observable";
import { IHeaderCommandBarItem } from "VSSUI/HeaderCommandBar";
import { IMenuItem } from "VSSUI/Menu";

import { ActiveReleaseColumnKeys } from "Release/Landing/Constants";
import * as Resources from "Release/Landing/Resources";

export namespace Keys {
    export const AllReleasesViewActionKey = "active-releases-all-rel-viewaction";
    export const CurrentlyDeployed = "currently-deployed-view-option-key";
    export const AllReleases = "all-releases-view-option-key";
}

export function getCurrentlyDeployedViewAction(currentlyDeployedValue: IObservableValue<string>): IHeaderCommandBarItem {
    const isCurrentlyDeployedEnabled = currentlyDeployedValue.value === Keys.CurrentlyDeployed;

    const currentlyDeployedDropdownChildItems: IMenuItem[] = [
        {
            id: Keys.CurrentlyDeployed,
            text: Resources.CurrentlyDeployed,
            iconProps: { iconName: "Cloudy" },
            onActivate: () => {
                if (!isCurrentlyDeployedEnabled) {
                    currentlyDeployedValue.value = Keys.CurrentlyDeployed;
                }
            }
        },
        {
            id: Keys.AllReleases,
            text: Resources.AllReleases,
            iconProps: { iconName: "ViewList" },
            onActivate: () => {
                if (isCurrentlyDeployedEnabled) {
                    currentlyDeployedValue.value = Keys.AllReleases;
                }
            }
        }
    ];

    const iconName = isCurrentlyDeployedEnabled ? "Cloudy" : "ViewList";
    return {
        id: Keys.AllReleasesViewActionKey,
        important: true,
        iconProps: { iconName: iconName },
        text: isCurrentlyDeployedEnabled ? Resources.CurrentlyDeployed : Resources.AllReleases,
        subMenuProps: {
            id: "currently-deployed-sub-menu",
            items: currentlyDeployedDropdownChildItems
        },
    };
}

export function getColumnOptionHeaderCommands(showDescriptionColumn: IObservableValue<boolean>, showTagsColumn: IObservableValue<boolean>): IHeaderCommandBarItem[] {
    return [{
        id: "column-options-command-key",
        important: false,
        text: Resources.ColumnOptionsMenuText,
        subMenuProps: {
            id: "column-options-submenu",
            items: [
                {
                    id: ActiveReleaseColumnKeys.ActiveReleaseDescriptionKey,
                    checked: showDescriptionColumn.value,
                    text: Resources.ActiveReleaseDescriptionHeaderText,
                    onActivate: () => {
                        const currentState = showDescriptionColumn.value;
                        showDescriptionColumn.value = !currentState;
                    }
                },
                {
                    id: ActiveReleaseColumnKeys.ActiveReleaseTagsKey,
                    checked: showTagsColumn.value,
                    text: Resources.ActiveReleaseTagsHeaderText,
                    onActivate: () => {
                        const currentState = showTagsColumn.value;
                        showTagsColumn.value = !currentState;
                    }
                }
            ]
        }
    }];
}
